// extracted by mini-css-extract-plugin
module.exports = {"typography":"_9fddc334","pre":"_2f94e633"};